import React, {useEffect, useState} from "react";
import {makeStyles} from '@material-ui/core/styles';
import PermissionService from "../../../services/PermissionsService";
import {toast, ToastContainer} from "react-toastify";
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";
import Spinner from "reactjs-simple-spinner";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        maxWidth: 752,
    },
    demo: {
        backgroundColor: theme.palette.background.paper,
    },
    title: {
        margin: theme.spacing(4, 0, 2),
    },
}));


const ManagePermissions = () => {

    const classes = useStyles();
    const [dense, setDense] = React.useState(false);
    const [secondary, setSecondary] = React.useState(false);
    const [assigned, setAssigned] = useState([]);
    const [unassigned, setUnassigned] = useState([]);
    const [loading, setLoading] = useState(true);
    const [updateLoading, setUpdateLoading] = useState(false);
    const role = JSON.parse(localStorage.getItem('role'));

    const handleUnAssign = (name) => {
        setUpdateLoading(true);
        console.log(name, role.id);
        let request = {
            'permission': name,
            'id': role.id
        }

        PermissionService.unAssignPermission(request)
            .then(res => {
                if (res.status === 200) {
                    console.log(res);
                    PermissionService.getAssignedPermission(role.id)
                        .then(res => {
                            if (res.status === 200) {
                                console.log("assigned: ", res.data);
                                setAssigned(res.data.permissions);
                                PermissionService.getUnAssignedPermission()
                                    .then(res => {
                                        console.log("perm", res.data);
                                        setUnassigned(res.data.data);
                                        setUpdateLoading(false);
                                        toast('Permission Un-Assigned Successfully', {
                                            position: "top-right",
                                            autoClose: 3000,
                                            hideProgressBar: false,
                                            closeOnClick: true,
                                            pauseOnHover: true,
                                            draggable: true,
                                            progress: undefined,
                                        });
                                    })
                                    .catch(err => {
                                        console.log(err);
                                        toast.warning('Operation Failed: ' + err.response.data.message, {
                                            position: "top-center",
                                            autoClose: 3000,
                                            hideProgressBar: false,
                                            closeOnClick: true,
                                            pauseOnHover: true,
                                            draggable: true,
                                            progress: undefined,
                                        });
                                        setUpdateLoading(false);
                                    });
                            } else {
                                toast.warning('Operation Failed: ' + res.response.data.message, {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                                setUpdateLoading(false);
                            }
                        })
                        .catch(err => {
                            console.log(err);
                            toast.warning('Operation Failed: ' + err.response.data.message, {
                                position: "top-center",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                            setUpdateLoading(false);
                        });

                } else {
                    console.log(res);
                    toast.warning('Operation Failed: ' + res.response.data.message, {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setUpdateLoading(false);
                }
            })
            .catch(err => {
                console.log(err);
                toast.warning('Operation Failed: ' + err.response.data.message, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setUpdateLoading(false);
            })

    }

    const handleAssign = (name) => {
        setUpdateLoading(true);
        console.log(name);
        let request = {
            'permission': name,
            'id': role.id
        }

        PermissionService.assignPermission(request)
            .then(res => {
                if (res.status === 200) {
                    console.log("after assign response: ", res);
                    PermissionService.getAssignedPermission(role.id)
                        .then(res => {
                            if (res.status === 200) {
                                console.log("new assigned: ", res.data);
                                setAssigned(res.data.permissions);

                                toast('Permission Assigned Successfully', {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                                setUpdateLoading(false);
                            } else {
                                toast.warning('Operation Failed: ' + res.response.data.message, {
                                    position: "top-center",
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                                setUpdateLoading(false);
                            }
                        }).catch(err => {
                        console.log("error assign: ", err);
                        toast.warning('Operation Failed: ' + err.response.data.message, {
                            position: "top-center",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        setUpdateLoading(false);
                    });

                } else {
                    console.log(res);
                    toast.warning('Operation Failed: ' + res.response.data.message, {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setUpdateLoading(false);
                }
            })
            .catch(err => {
                console.log(err);
                toast.warning('Operation Failed: ' + err.response.data.message, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setUpdateLoading(false);
            })

    }


    useEffect(() => {
        const roleId = role.id;
        setLoading(true);
        setUpdateLoading(false);
        PermissionService.getAssignedPermission(roleId)
            .then(res => {
                if (res.status === 200) {
                    console.log("assigned: ", res.data);
                    setAssigned(res.data.permissions);
                    PermissionService.getUnAssignedPermission()
                        .then(res => {
                            console.log("perm", res.data);
                            setUnassigned(res.data.data);
                            setLoading(false);
                        })
                        .catch(err => {
                            console.log(err);
                            setLoading(false);
                        });
                } else {
                    setLoading(false);
                }

            })
            .catch(err => {
                console.log(err);
                setLoading(false);
            });

    }, []);

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            {/* Same as */}
            <ToastContainer/>

            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div
                id="main-content"
                className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>

                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                             &nbsp;|&nbsp;
                            <Link to="/settings"><a href><i className="fa fa-cog"/>&nbsp;Settings</a></Link>
                             &nbsp;|&nbsp;
                            <Link to="/roles"><a href><i className="fa fa-users-cog"/>&nbsp;IAM Roles
                                Management</a></Link>
                             &nbsp;|&nbsp;
                            <Link to="/view-permissions"><a href><i className="fa fa-user-cog"/>&nbsp;Manage Roles &
                                Permissions</a></Link>
                             &nbsp;|&nbsp;
                            <span className="upper-class"><span
                                className="text-uppercase"><b>{role.name}</b></span></span>
                        </ul>
                        <div className="row mt">
                            <div className="col-lg-12">
                                <div className="content-panel">
                                    {loading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="large"
                                                message="Getting Data,Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>
                                    )}
                                    {updateLoading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="large"
                                                message="Please wait,Good things takes time....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>
                                    )}
                                    {!loading && !updateLoading && (
                                        <>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="card">
                                                        <div className="card-header">
                                                            <h4><i className="fa fa-2x fa-lock"/>&nbsp;Assigned</h4>
                                                        </div>
                                                        <div className="card-body">
                                                            <Grid item xs={12} md={8}>
                                                                <Typography variant="h6" className={classes.title}>
                                                                    Assigned Permissions
                                                                </Typography>
                                                                <div className={classes.demo}>
                                                                    <List dense={dense}>
                                                                        {assigned.map((pem, p) => (
                                                                            <ListItem key={p}>
                                                                                {/*<ListItemAvatar>*/}
                                                                                {/*    <Avatar>*/}
                                                                                {/*        <FolderIcon />*/}
                                                                                    {/*    </Avatar>*/}
                                                                                    {/*</ListItemAvatar>*/}
                                                                                    <ListItemText
                                                                                        primary={pem.name}
                                                                                        secondary={secondary ? 'Secondary text' : null}
                                                                                    />
                                                                                    <ListItemSecondaryAction>
                                                                                        <button
                                                                                            onClick={() => handleUnAssign(pem.name)}
                                                                                            className=" btn btn-sm btn-round btn-danger">
                                                                                            Un-assign&nbsp;&nbsp;<i
                                                                                            className="fa fa-remove"/>
                                                                                        </button>
                                                                                    </ListItemSecondaryAction>
                                                                                </ListItem>
                                                                            )
                                                                        )}
                                                                    </List>
                                                                </div>
                                                            </Grid>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="card">
                                                        <div className="card-header">
                                                            <h4><i className="fa fa-2x fa-lock-open"/>&nbsp;UnAssigned
                                                            </h4>
                                                        </div>
                                                        <div className="card-body">
                                                            <Grid item xs={12} md={8}>
                                                                <Typography variant="h6" className={classes.title}>
                                                                    unAssigned Permissions
                                                                </Typography>
                                                                <div className={classes.demo}>
                                                                    <List dense={dense}>
                                                                        {unassigned.map((pem, p) => (
                                                                            <ListItem>
                                                                                {/*<ListItemAvatar>*/}
                                                                                {/*    <Avatar>*/}
                                                                                {/*        <FolderIcon />*/}
                                                                                {/*    </Avatar>*/}
                                                                                {/*</ListItemAvatar>*/}
                                                                                <ListItemText
                                                                                    primary={pem.name}
                                                                                    secondary={secondary ? 'Secondary text' : null}
                                                                                />
                                                                                <ListItemSecondaryAction>
                                                                                    <button
                                                                                        onClick={() => handleAssign(pem.name)}
                                                                                        className="btn btn-sm btn-round btn-success">
                                                                                        assign&nbsp;&nbsp;<i
                                                                                        className="fa fa-check-circle"/>
                                                                                    </button>
                                                                                </ListItemSecondaryAction>
                                                                            </ListItem>
                                                                        ))}
                                                                    </List>
                                                                </div>
                                                            </Grid>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ManagePermissions;
